module.exports = "<input \n  type=\"email\" \n  class=\"form-control{{$ctrl.class ? ' ' + $ctrl.class : ''}}\"\n  ng-model=\"$ctrl.ngModel\"\n  placeholder=\"{{$ctrl.placeholder || 'email@example.com'}}\"\n  ng-disabled=\"$ctrl.disabled\"\n  ng-required=\"$ctrl.required\">\n</input>\n\n";


//////////////////
// WEBPACK FOOTER
// ./client/common/directives/email/tc-email.html
// module id = 557
// module chunks = 0